import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'data',
    ]),
  },
  data() {
    return {
      mouseOverId: null,
    }
  },
  methods: {
    ...mapActions([
      'setArray',
      'setData',
      'setValue',
    ]),
    m_over(id){
      this.mouseOverId = id
    },
    m_out(id){
      this.mouseOverId = null
    },
    slideToContent(id) {
      let slideToBlock = setInterval(function () {
        $("#jobCategoryModal").animate({
          scrollTop: $("#jobCategoryModal .js-content-"+ id)[0].offsetTop
        }, 300);
        if ($("#jobCategoryModal .js-content-"+ id).length > 0) clearInterval(slideToBlock)
      }, 300)
    }
  }
}
